module.exports = __webpack_public_path__ + "static/media/ODIO-LADY.5faaa72f.png";